import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Card,
  Typography,
  CardContent,
  Grid,
  Backdrop,
  TextField,
  Tooltip,
  Button,
  Link as MuiLink,
} from "@material-ui/core";
import moment from "moment";
import "moment-timezone";
import { filterBy } from "src/common/utils/helpers";
import { useDispatch } from "react-redux";
import TabHeader from "src/components/TabHeader/TabHeader";
import { useStyles } from "./style";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { useFormik } from "formik";
import { object, string } from "yup";
import { GridRowModel } from "@material-ui/x-grid";
import CommonButton from "src/components/CommonButton/CommonButton";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import MultiSelect2 from "src/components/molecules/MultiSelect2";
import { useAppSelector } from "src/app-redux/hooks";
import { selectPaymentTypes } from "src/app-redux/commercial/commercialSlice";
import { loader as vehicleLoader, setSelectedVehicleId } from "src/app-redux/vehicle/vehicleSlice";
import Drawer from "src/modules/vehicle-management/pages/ListVehicles/components/Drawer";
import CommonLoader from "src/components/Loader/CommonLoader";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { ExamType, filteryByArr } from "src/common/utils/app.dropdowns";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";

interface Props {}

export function ExaminationReport({}: Props): React.ReactElement {
  const columns = [
    {
      accessorKey: "performedDate",
      header: "Date",
      type: "string",
      size: 200,
      accessorFn: function customCell(row: any) {
        return `${
          row.performedDate ? moment(row.performedDate).format("DD-MM-YYYY hh:mm:ss A") : ""
        }`;
      },
    },
    {
      accessorKey: "virNumber",
      header: "Vir Number",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.virNumber || " "}`,
    },
    {
      accessorKey: "vessel",
      header: "Vessel",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.vessel || " "}`,
    },
    {
      accessorKey: "voyage",
      header: "Voyage",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.voyage || " "}`,
    },
    {
      accessorKey: "type",
      header: "Type",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.type || " "}`,
    },
    {
      accessorKey: "containerNumber",
      header: "Container #",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.containerNumber || " "}`,
    },
    {
      accessorKey: "billNumber",
      header: "Bill Number",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.billNumber || " "}`,
    },
    {
      accessorKey: "indexNo",
      header: "Index Number",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.indexNo || " "}`,
    },
    {
      accessorKey: "gdNumber",
      header: "GD Number",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.gdNumber || " "}`,
    },
    {
      accessorKey: "goodDescription",
      header: "Goods Description",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.goodDescription || " "}`,
    },
    {
      accessorKey: "foundPackages",
      header: "Found No of Packages",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.foundPackages || " "}`,
    },
    {
      accessorKey: "foundWeight",
      header: "Found Weight",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.foundWeight || " "}`,
    },
    {
      accessorKey: "location",
      header: "Location",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.location || " "}`,
    },
    {
      accessorKey: "executionOrder",
      header: "Execution Order",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.executionOrder || " "}`,
    },
    {
      accessorKey: "handlingCode",
      header: "Handling Code",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.handlingCode || " "}`,
    },
    {
      accessorKey: "handling",
      header: "Handling",
      type: "string",
      size: 200,
      accessorFn: (row: any) => ` ${row.handling || " "}`,
    },
  ];
  const classes = useStyles();

  const moduleName = "Examination Report";
  const pageHeading = "Examination Report";
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [gridRecord, setGridRecord] = React.useState<GridRowModel[]>([]);
  const [loader, setLoader] = useState<any>(false);
  const terminalLocationRef: any = useRef();
  const multiselectRef: any = useRef();
  const containerlStatusMultiselectRef: any = useRef();
  const consignmentTypeMultiselectRef: any = useRef();
  const paymentTypeMultiselectRef: any = useRef();
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const loader2: any = useAppSelector(vehicleLoader);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);
  const dispatch = useDispatch();

  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };
  const validationSchema = object({
    startDate: string().required("This field is required."),
    endDate: string().required("This field is required."),
  });

  const formik = useFormik({
    initialValues: {
      type: "Pending",
      filterBy: "today",
      startDate: moment().startOf("day").format("YYYY-MM-DDTHH:mm"),
      endDate: moment().endOf("day").format("YYYY-MM-DDTHH:mm"),
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const body = {
        startDate: values.startDate || null,
        endDate: values.endDate || null,
      };
      if (values.type === "Pending") {
        setGridRecord([]);
        setLoader(true);
        try {
          const results = await fetchWrapper.post("get-pending-examination-report", body);
          setGridRecord(results?.value?.pendingExaminations || []);
          setDisplayColumns(columns);
        } catch (error) {
          setLoader(false);
        }
        setLoader(false);
      }
      if (values.type === "Completed") {
        setGridRecord([]);
        setLoader(true);
        try {
          const results = await fetchWrapper.post("get-complete-examination-report", body);
          setGridRecord(results?.value?.completeExaminations || []);
          setDisplayColumns(columns);
        } catch (error) {
          setLoader(false);
        }
        setLoader(false);
      }
      if (values.type === "Hold") {
        setGridRecord([]);
        setLoader(true);
        try {
          // TODO: Replace with actual hold API once available
          const results = await fetchWrapper.post("get-hold-examination-report", body);
          setGridRecord(results?.value?.holdExaminations || []);
          setDisplayColumns(columns);
        } catch (error) {
          setLoader(false);
        }
        setLoader(false);
      }
    },
  });
  const exportHandler = async (rows: any[]) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );

    const exportedRecords = rows.map((data: any) => {
      return {
        Date: data?.performedDate
          ? moment(data?.performedDate).format("DD-MM-YYYY hh:mm:ss A")
          : "",
        "VIR Number": data?.virNumber || "",
        Vessel: data?.vessel || "",
        Voyage: data?.voyage || "",
        Type: data?.type || "",
        "Container Number": data?.containerNumber || "",
        "Bill Number": data?.billNumber || "",
        "Index Number": data?.indexNo || "",
        "GD Number": data?.gdNumber || "",
        "Goods Description": data?.goodDescription || "",
        "Found Packages": data?.foundPackages || "",
        "Found Weight": data?.foundWeight || "",
        Location: data?.location || "",
        "Execution Order": data?.executionOrder || "",
        "Handling Code": data?.handlingCode || "",
        Handling: data?.handling || "",
      };
    });

    return exportedRecords;
  };

  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };
  const resetSearch = () => {
    terminalLocationRef?.current ? terminalLocationRef.current?.getUpdated() : "";
    multiselectRef?.current ? multiselectRef.current?.getUpdated() : "";
    containerlStatusMultiselectRef?.current
      ? containerlStatusMultiselectRef.current?.getUpdated()
      : "";
    paymentTypeMultiselectRef?.current ? paymentTypeMultiselectRef.current?.getUpdated() : "";
    consignmentTypeMultiselectRef?.current
      ? consignmentTypeMultiselectRef.current?.getUpdated()
      : "";

    formik.resetForm();
    setGridRecord([]);
  };
  const fetchData = async () => {
    const body = {
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
    };
    setGridRecord([]);
    setLoader(true);
    try {
      const results = await fetchWrapper.post("get-pending-examination-report", body);
      setGridRecord(results?.value?.pendingExaminations || []);
      setDisplayColumns(columns);
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} />
      <Backdrop className={classes.backdrop} open={loader}>
        <CommonLoader />
      </Backdrop>
      {!loader2 && (
        <Drawer
          isDrawerOpen={isDrawerOpen}
          handleCloseDrawer={() => {
            handleCloseDrawer();
          }}
        />
      )}

      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} direction="row">
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => formik.submitForm()}
                >
                  Search
                </CommonButton>
              </Box>
            </Grid>
          </Grid>

          <>
            <Grid spacing={1} container direction="row">
              <Grid item xs={12} md={3} lg={2}>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                  helperText={formik.touched.filterBy && formik.errors.filterBy}
                  label="Filter by"
                  placeholder="Filter by"
                  name="filterBy"
                  disableClearable={true}
                  optionsType={filteryByArr}
                  getOptionLabel={(option: any) => option.label || null}
                  onChange={(row: any) => {
                    row ? formik.setValues({ ...formik.values, filterBy: row.value || "" }) : "";
                    if (row === null) {
                      formik.setFieldValue("filterBy", null);
                    }
                    filterByAction(row);
                  }}
                  value={
                    filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"Start Date"}
                  name={"startDate"}
                  datePickerRef={startDatePickerRef}
                  value={formik.values.startDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                    formik.setFieldValue("endDate", "");
                  }}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"End Date"}
                  name={"endDate"}
                  datePickerRef={endDatePickerRef}
                  value={formik.values.endDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  }}
                  minDate={formik.values.startDate}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid item xs={12} md={3} lg={2} style={{ paddingRight: 0 }}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="Examination Type"
                    name="type"
                    optionsType={ExamType}
                    placeholder="Select Examination Type"
                    getOptionLabel={(option: any) => option || ""}
                    value={formik.values.type || null}
                    onChange={(option: any) => {
                      formik.setFieldValue("type", option || "");
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
          <CommonMaterialGrid
            rows={gridRecord}
            columns={displayColumns}
            defaultPerPageRecord={50}
            loader={loader}
            height={600}
            isExport={isExport}
            exportHandler={exportHandler}
            filename={`Examination_report_${Date.now()}`}
            isFooter={true}
          />
        </CardContent>
      </Card>
    </>
  );
}
